import { Flag } from 'lucide-react';

const FlagShowcase = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-ocean-blue from-opacity-10 to-sea-green to-opacity-10">
      <div className="container mx-auto px-4">
        <h2 className="section-header text-center mb-12">Te Haki o nga Iwi Kotahi - United Tribes Flag</h2>
        
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div className="flex justify-center">
              <div className="bg-white rounded-lg shadow-xl p-6">
                <img 
                  src="/assets/docs/image004.jpg" 
                  alt="United Tribes Flag of New Zealand - Te Haki o nga Iwi Kotahi"
                  className="rounded-lg max-w-full h-auto border-2 border-ocean-blue border-opacity-30"
                />
                <p className="text-center text-sm text-gray-600 mt-4">
                  The United Tribes Flag - Chosen by 25 chiefs at Waitangi, 20 March 1834
                </p>
              </div>
            </div>
            
            <div className="flex items-center">
              <div className="card">
                <div className="flex items-start mb-4">
                  <Flag className="h-8 w-8 text-ocean-teal mr-4 mt-1" />
                  <h3 className="text-xl font-semibold text-ocean-deep">Historical Significance</h3>
                </div>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="bg-ocean-blue bg-opacity-20 text-ocean-teal rounded-full w-6 h-6 flex items-center justify-center text-sm font-semibold mr-3 mt-1">1</span>
                    <span>Chosen by 25 Far North chiefs at Waitangi on 20 March 1834</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-ocean-blue bg-opacity-20 text-ocean-teal rounded-full w-6 h-6 flex items-center justify-center text-sm font-semibold mr-3 mt-1">2</span>
                    <span>Received 12 out of 25 votes from the assembled chiefs</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-ocean-blue bg-opacity-20 text-ocean-teal rounded-full w-6 h-6 flex items-center justify-center text-sm font-semibold mr-3 mt-1">3</span>
                    <span>Declared national flag with 21-gun salute from HMS Alligator</span>
                  </li>
                  <li className="flex items-start">
                    <span className="bg-ocean-blue bg-opacity-20 text-ocean-teal rounded-full w-6 h-6 flex items-center justify-center text-sm font-semibold mr-3 mt-1">4</span>
                    <span>Approved by King William IV and internationally recognized</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="card bg-white">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Flag Design Elements</h3>
            <div className="grid md:grid-cols-4 gap-4">
              <div className="text-center">
                <div className="bg-blue-600 w-12 h-12 rounded-full mx-auto mb-2"></div>
                <h4 className="font-semibold text-sm">Blue Quarters</h4>
                <p className="text-xs text-gray-600">Four blue sections with white stars</p>
              </div>
              <div className="text-center">
                <div className="bg-red-600 w-12 h-12 rounded-full mx-auto mb-2"></div>
                <h4 className="font-semibold text-sm">Red Cross</h4>
                <p className="text-xs text-gray-600">St. George's Cross pattern</p>
              </div>
              <div className="text-center">
                <div className="bg-white border-2 border-gray-300 w-12 h-12 rounded-full mx-auto mb-2 flex items-center justify-center">
                  <span className="text-yellow-400 text-xl">★</span>
                </div>
                <h4 className="font-semibold text-sm">Eight-Point Stars</h4>
                <p className="text-xs text-gray-600">Traditional navigation stars</p>
              </div>
              <div className="text-center">
                <div className="bg-white border-2 border-gray-300 w-12 h-12 rounded-full mx-auto mb-2"></div>
                <h4 className="font-semibold text-sm">White Background</h4>
                <p className="text-xs text-gray-600">Purity and peace</p>
              </div>
            </div>
          </div>

          <div className="card bg-ocean-blue bg-opacity-10 mt-8">
            <h3 className="text-xl font-semibold mb-4 text-ocean-deep">Constitutional Status Today</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              The United Tribes Flag remains the only constitutionally recognized flag of New Zealand with 
              international legal status. It is protected under Article 4 of He Whakaputanga and recognized 
              under the GATT agreement by 74 countries.
            </p>
            <div className="bg-ocean-blue bg-opacity-20 rounded-lg p-4">
              <p className="text-ocean-deep font-medium">
                "Any other flag that is not constituted is unlawful. The United Tribes flag is the foundation 
                that ties all Māori to the constitutional framework established in 1835."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlagShowcase;